module.exports = __webpack_public_path__ + "img/pt-r.7fe8a333.jpg";